import React from 'react';
import { useApplicationVideoEvent } from '../../hooks/analytics/useApplicationVideoEvent';
import { VideoModal } from '../VideoModal/VideoModal.web';
import { ApplicationVideoModalProps } from './interface';
import { useApplicationVideoConfig } from '@mp/hooks/useApplicationVideoConfig/useApplicationVideoConfig.web';

export const ApplicationVideoModal = ({ isOpen, onClose, source }: ApplicationVideoModalProps) => {
  const { videoUrl } = useApplicationVideoConfig();
  const { trackVideoPlayed, trackDismissed } = useApplicationVideoEvent();

  const handleClose = () => {
    trackDismissed({ platform: 'web', source });
    onClose();
  };

  const handleVideoPlayed =
    source === 'auto' ? () => trackVideoPlayed({ platform: 'web', source }) : undefined;

  return (
    <VideoModal
      isOpen={isOpen}
      onClose={handleClose}
      videoUrl={videoUrl}
      onVideoPlayed={handleVideoPlayed}
      iframeId="application-video-iframe"
      testId="application-video"
    />
  );
};
